export const PDP_VISITED_EVENT_TYPE = "pdp_visited";
